module.exports = __webpack_public_path__ + "static/img/cont61 (3).d1c5f53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont61 (3).jpg
// module id = bMOF
// module chunks = 0